import { render } from "./VtoSubentitySelection.vue?vue&type=template&id=5500cc3c"
import script from "./VtoSubentitySelection.vue?vue&type=script&lang=js"
export * from "./VtoSubentitySelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__